export default "__VITE_ASSET__a217dbc4__"